import { useFormContext } from 'react-hook-form';

import { SelectItem } from '@/components/core/Select';
import { DataModelAttribute, DataModelAttributeOption } from '@/types/DataModel';

import { useOptionTranslator } from '../hooks/useOptionTranslator';

interface DimensionSelectItemProps {
    dimension: DataModelAttributeOption;
    fieldPath: string;
    attribute: DataModelAttribute;
}

const DimensionSelectItem = ({ dimension, fieldPath, attribute }: DimensionSelectItemProps) => {

    const { watch } = useFormContext();
    const currentDimensionValue = watch(fieldPath, '');
    const { translateOption } = useOptionTranslator();

    return (
        <SelectItem key={dimension.key} value={dimension.key} className="tw-overflow-hidden">
            <a>
                <div className="tw-flex tw-w-full">
                    <span className="tw-font-bold">{translateOption(dimension.key, attribute, attribute.options)}</span>
                    <span className="tw-mr-2">|</span>
                    <span className="tw-flex-1 tw-truncate tw-overflow-hidden">{currentDimensionValue}</span>
                </div>
            </a>
        </SelectItem>
    );
};

export { DimensionSelectItem };
